import { Component, OnInit } from '@angular/core';
import { CMSService } from 'src/app/services/CMS/cms.service';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

@Component({
  selector: 'app-slider',
  templateUrl: './slider.component.html',
  styleUrls: ['./slider.component.css']
})
export class SliderComponent implements OnInit {
  SelectedFileForHeaderLogoUpload: any;
  JosaUrlList: any;
  SelectedFileForFooterLogoUpload: any;
  SliderList: any;
  Submitted: boolean = false;

  constructor(private cmsservice: CMSService, private LookupService: LookupService,
    public globalHelper: GlobalHelper, private spinnerService: Ng4LoadingSpinnerService) { }

    SliderModel = {
      SliderMessage: '',
      SliderID: 0,
      IsActive: true,
      JOSAURLID: 0,
      SliderPath:'',
  };

 
    ClearSlider() {
      this.SliderModel.SliderMessage = '';
      this.SliderModel.SliderID = 0;
      this.SliderModel.SliderPath ='';
    }

    EditSlider(obj) {
      this.SliderModel.SliderMessage = obj.SliderMessage;
            this.SliderModel.SliderID = obj.SliderID;
            this.SliderModel.SliderPath = obj.src;
            this.SliderModel.IsActive = obj.IsActive;
    }

    SaveSlider(valid) {

      this.Submitted = true;
      if (valid) {
        this.spinnerService.show();
        this.cmsservice.SaveSlider(JSON.stringify(this.SliderModel), this.SelectedFileForHeaderLogoUpload).subscribe((data: any) => {
          if (data.webResponse.Status) {
            this.GetSlider();
          }
          if (data.webResponse.Status && this.SliderModel.SliderID == 0) {
            this.ClearSlider();
            this.GetSlider();
          }
          this.globalHelper.CheckActionStatus(data);
          this.spinnerService.hide();
        });
      }
  
    };

    SliderMarkActive(obj) {
      
      this.SliderModel.SliderID = obj.SliderID;
      this.SliderModel.IsActive = obj.IsActive == true ? false : true;
      this.spinnerService.show();
      this.cmsservice.SliderMarkActive(JSON.stringify(this.SliderModel)).subscribe((data: any) => {
        this.spinnerService.hide();
          this.ClearSlider();
          this.GetSlider();
  
          this.globalHelper.CheckActionStatus(data);
  
      });
  }

    selectFileforHeaderLogoUpload(file) {
      this.SelectedFileForHeaderLogoUpload = file[0];
    };


    Validation() {
      return this.SliderModel.JOSAURLID == 0;
    }

   
    GetSlider() {
      this.cmsservice.GetSlider(this.SliderModel.JOSAURLID).subscribe((data: any) => {
          this.SliderList = data.SliderList;
         this.globalHelper.CheckActionStatus(data);
      });
  };

  ngOnInit() {
   
    this.GetJosaUrl();
  }

  GetJosaUrl() {
    this.LookupService.GetLookupsList('JosaUrl', '').subscribe((data: any) => {
      this.JosaUrlList = data.LookupItems;
    });
  };

}


